module.exports = __webpack_public_path__ + "assets/img/warrior-name-459bc5ca.png";